import { AIRWALLEX_GLOBAL_TOS } from '@/constants/consents';
import { ConsentService } from '@/services/ConsentService';
import { Link, Typography } from '@mui/material';
import { t } from 'i18next';

export const CopyrightDisclaimer = () => {
  const { getTOS } = ConsentService;
  return (
    <Typography variant="body1" color="text.secondary" display="inline">
      {t('by_signing_up_you_agree_to_treyd')}{' '}
      <Typography
        component={Link}
        href={getTOS()?.link}
        sx={{ textDecoration: 'none' }}
        target="_blank"
        variant="body1"
        color="info.main"
        display="inline">
        {t('platform_terms_and_conditions')}
      </Typography>
      {t('and_airwallex')}{' '}
      <Typography
        variant="body1"
        sx={{ textDecoration: 'none' }}
        component={Link}
        display="inline"
        href={AIRWALLEX_GLOBAL_TOS}
        target="_blank"
        color="info">
        {t('connection_account_user_terms')}
      </Typography>
    </Typography>
  );
};
